import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode } from "vue"
import _imports_0 from '@/assets/icon/amway-cc-logo-b.svg'
import _imports_1 from '@/assets/icon/icon-team.svg'
import _imports_2 from '@/assets/icon/icon-reward.svg'
import _imports_3 from '@/assets/icon/icon-group-people.svg'
import _imports_4 from '@/assets/icon/icon-register-w.svg'
import _imports_5 from '@/assets/icon/icon-people.svg'
import _imports_6 from '@/assets/icon/icon-edit-profile.svg'
import _imports_7 from '@/assets/icon/icon-back-to.svg'
import _imports_8 from '@/assets/icon/amway-cc-logo-m.svg'
import _imports_9 from '@/assets/icon/icon-back.svg'
import _imports_10 from '@/assets/images/board/firework-team-m.svg'
import _imports_11 from '@/assets/images/board/reward-w1-5.svg'
import _imports_12 from '@/assets/images/board/reward-w1-5-m.svg'
import _imports_13 from '@/assets/images/board/reward-w6-10.svg'
import _imports_14 from '@/assets/images/board/reward-w6-10-m.svg'
import _imports_15 from '@/assets/icon/icon-circle-star.svg'
import _imports_16 from '@/assets/images/board/medal.svg'
import _imports_17 from '@/assets/icon/amway-logo.svg'
import _imports_18 from '@/assets/icon/icon-phone.svg'


const _hoisted_1 = { class: "leader-board" }
const _hoisted_2 = { class: "header w-sub-header" }
const _hoisted_3 = { class: "header-area desktop" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "Amway Creator Challenge"
}, null, -1)
const _hoisted_5 = { class: "header-right" }
const _hoisted_6 = { class: "header-menu" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("img", { src: _imports_1 }, null, -1)
const _hoisted_8 = /*#__PURE__*/_createTextVNode("คะแนนทีมของคุณ")
const _hoisted_9 = /*#__PURE__*/_createElementVNode("img", { src: _imports_2 }, null, -1)
const _hoisted_10 = /*#__PURE__*/_createTextVNode("ผลการแข่งขันรายสัปดาห์")
const _hoisted_11 = /*#__PURE__*/_createElementVNode("img", { src: _imports_2 }, null, -1)
const _hoisted_12 = /*#__PURE__*/_createTextVNode("ประกาศผลรางวัลชนะเลิศ")
const _hoisted_13 = /*#__PURE__*/_createElementVNode("img", { src: _imports_3 }, null, -1)
const _hoisted_14 = /*#__PURE__*/_createTextVNode("คะแนนทีมของคุณ")
const _hoisted_15 = /*#__PURE__*/_createElementVNode("img", { src: _imports_2 }, null, -1)
const _hoisted_16 = /*#__PURE__*/_createTextVNode("ผลการแข่งขันรายสัปดาห์")
const _hoisted_17 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_4 }),
  /*#__PURE__*/_createTextVNode("รายละเอียดกิจกรรม")
], -1)
const _hoisted_18 = { class: "profile-area" }
const _hoisted_19 = ["src"]
const _hoisted_20 = {
  class: "profile-info",
  id: "profile-info"
}
const _hoisted_21 = { class: "profile-info-area" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("img", { src: _imports_5 }, null, -1)
const _hoisted_23 = { class: "profile-info-name" }
const _hoisted_24 = { class: "profile-info-id" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("img", { src: _imports_6 }, null, -1)
const _hoisted_26 = /*#__PURE__*/_createTextVNode("โปรไฟล์ของฉัน ")
const _hoisted_27 = /*#__PURE__*/_createElementVNode("a", {
  href: "https://www.amway.co.th",
  class: "link-red"
}, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_7 }),
  /*#__PURE__*/_createTextVNode("กลับไปยังเว็บไซต์หลัก ")
], -1)
const _hoisted_28 = { class: "header-area mobile" }
const _hoisted_29 = { class: "header-logo-area" }
const _hoisted_30 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_8,
  alt: "Amway Creator Challenge"
}, null, -1)
const _hoisted_31 = {
  class: "profile-area",
  id: "profile-area-m"
}
const _hoisted_32 = ["src"]
const _hoisted_33 = {
  class: "profile-info",
  id: "profile-info-m"
}
const _hoisted_34 = { class: "profile-info-area" }
const _hoisted_35 = /*#__PURE__*/_createElementVNode("img", { src: _imports_5 }, null, -1)
const _hoisted_36 = { class: "profile-info-name" }
const _hoisted_37 = { class: "profile-info-id" }
const _hoisted_38 = /*#__PURE__*/_createElementVNode("img", { src: _imports_6 }, null, -1)
const _hoisted_39 = /*#__PURE__*/_createTextVNode("โปรไฟล์ของฉัน ")
const _hoisted_40 = /*#__PURE__*/_createElementVNode("a", {
  href: "https://www.amway.co.th",
  class: "link-red"
}, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_7 }),
  /*#__PURE__*/_createTextVNode("กลับไปยังเว็บไซต์หลัก ")
], -1)
const _hoisted_41 = {
  class: "sub-menu",
  id: "sub-menu"
}
const _hoisted_42 = /*#__PURE__*/_createElementVNode("img", { src: _imports_1 }, null, -1)
const _hoisted_43 = /*#__PURE__*/_createTextVNode("คะแนนทีมของคุณ ")
const _hoisted_44 = /*#__PURE__*/_createElementVNode("img", { src: _imports_2 }, null, -1)
const _hoisted_45 = /*#__PURE__*/_createTextVNode("ผลการแข่งขันรายสัปดาห์ ")
const _hoisted_46 = /*#__PURE__*/_createElementVNode("img", { src: _imports_2 }, null, -1)
const _hoisted_47 = /*#__PURE__*/_createTextVNode("ประกาศผลรางวัลชนะเลิศ ")
const _hoisted_48 = /*#__PURE__*/_createElementVNode("img", { src: _imports_3 }, null, -1)
const _hoisted_49 = /*#__PURE__*/_createTextVNode("คะแนนทีมของคุณ ")
const _hoisted_50 = /*#__PURE__*/_createElementVNode("img", { src: _imports_2 }, null, -1)
const _hoisted_51 = /*#__PURE__*/_createTextVNode("ผลการแข่งขันรายสัปดาห์ ")
const _hoisted_52 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_4 }),
  /*#__PURE__*/_createTextVNode("รายละเอียดกิจกรรม ")
], -1)
const _hoisted_53 = { class: "header-area sticky mobile" }
const _hoisted_54 = /*#__PURE__*/_createElementVNode("img", { src: _imports_9 }, null, -1)
const _hoisted_55 = /*#__PURE__*/_createElementVNode("div", null, "ผลการแข่งขันรายสัปดาห์", -1)
const _hoisted_56 = { class: "leader-board-content" }
const _hoisted_57 = { class: "container" }
const _hoisted_58 = { class: "title-area" }
const _hoisted_59 = { class: "btn-back-area" }
const _hoisted_60 = /*#__PURE__*/_createElementVNode("img", { src: _imports_9 }, null, -1)
const _hoisted_61 = /*#__PURE__*/_createTextVNode(" กลับ")
const _hoisted_62 = { class: "title-page-area" }
const _hoisted_63 = { class: "title-week" }
const _hoisted_64 = { key: 0 }
const _hoisted_65 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_10,
  class: "firework-team mobile"
}, null, -1)
const _hoisted_66 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_11,
  class: "title-image"
}, null, -1)
const _hoisted_67 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_12,
  class: "title-image-m"
}, null, -1)
const _hoisted_68 = [
  _hoisted_65,
  _hoisted_66,
  _hoisted_67
]
const _hoisted_69 = { key: 1 }
const _hoisted_70 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_10,
  class: "firework-team mobile"
}, null, -1)
const _hoisted_71 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_13,
  class: "title-image"
}, null, -1)
const _hoisted_72 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_14,
  class: "title-image-m"
}, null, -1)
const _hoisted_73 = [
  _hoisted_70,
  _hoisted_71,
  _hoisted_72
]
const _hoisted_74 = { class: "myteam-table" }
const _hoisted_75 = /*#__PURE__*/_createStaticVNode("<div class=\"mtt-head\"><div class=\"mtt-col\">อันดับที่</div><div class=\"mtt-col\">ทีมของคุณ</div><div class=\"mtt-col\">คะแนนรวม</div><div class=\"mtt-col\">ของรางวัล</div></div>", 1)
const _hoisted_76 = { class: "mtt-row" }
const _hoisted_77 = { class: "mtt-col" }
const _hoisted_78 = { class: "tag-green" }
const _hoisted_79 = { class: "mtt-col" }
const _hoisted_80 = { class: "mtt-col" }
const _hoisted_81 = {
  key: 0,
  class: "mtt-col"
}
const _hoisted_82 = {
  key: 1,
  class: "mtt-col"
}
const _hoisted_83 = {
  key: 2,
  class: "mtt-col"
}
const _hoisted_84 = {
  key: 3,
  class: "mtt-col"
}
const _hoisted_85 = {
  key: 4,
  class: "mtt-col"
}
const _hoisted_86 = {
  key: 5,
  class: "mtt-col"
}
const _hoisted_87 = { class: "mtt-row" }
const _hoisted_88 = { style: {"width":"100%","margin-bottom":"24px"} }
const _hoisted_89 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_15,
    style: {"width":"34px","height":"34px","margin-right":"12px"}
  }),
  /*#__PURE__*/_createTextVNode("รายละเอียดคะแนน")
], -1)
const _hoisted_90 = { class: "table-d" }
const _hoisted_91 = { class: "rank-table" }
const _hoisted_92 = /*#__PURE__*/_createStaticVNode("<div class=\"rt-head\"><div class=\"rth-row\"><img src=\"" + _imports_16 + "\" class=\"rt-medal\"><div class=\"rt-title\">อันดับที่ 1-20</div></div><div class=\"rth-row\"><div class=\"rth-col\">สมาชิกที่เป็นนธอ.ใหม่</div><div class=\"rth-col\">การเข้าเรียน</div><div class=\"rth-col\">การโพสต์คอนเทนต์</div><div class=\"rth-col\">การสปอนเซอร์</div><div class=\"rth-col\">คะแนนรวม</div></div></div>", 1)
const _hoisted_93 = { class: "rt-content" }
const _hoisted_94 = /*#__PURE__*/_createElementVNode("div", { class: "rt-col" }, null, -1)
const _hoisted_95 = { class: "rt-col" }
const _hoisted_96 = { class: "rt-col" }
const _hoisted_97 = { class: "rt-col" }
const _hoisted_98 = /*#__PURE__*/_createTextVNode(" คะแนน")
const _hoisted_99 = { class: "rt-col" }
const _hoisted_100 = /*#__PURE__*/_createTextVNode(" คะแนน")
const _hoisted_101 = { class: "rt-col" }
const _hoisted_102 = /*#__PURE__*/_createTextVNode(" คะแนน")
const _hoisted_103 = { class: "rt-col" }
const _hoisted_104 = /*#__PURE__*/_createTextVNode(" คะแนน")
const _hoisted_105 = { class: "rt-col" }
const _hoisted_106 = /*#__PURE__*/_createTextVNode(" คะแนน")
const _hoisted_107 = { class: "rank-table" }
const _hoisted_108 = /*#__PURE__*/_createStaticVNode("<div class=\"rt-head\"><div class=\"rth-row\"><img src=\"" + _imports_16 + "\" class=\"rt-medal\"><div class=\"rt-title\">อันดับที่ 21-40</div></div><div class=\"rth-row\"><div class=\"rth-col\">สมาชิกที่เป็นนธอ.ใหม่</div><div class=\"rth-col\">การเข้าเรียน</div><div class=\"rth-col\">การโพสต์คอนเทนต์</div><div class=\"rth-col\">การสปอนเซอร์</div><div class=\"rth-col\">คะแนนรวม</div></div></div>", 1)
const _hoisted_109 = { class: "rt-content" }
const _hoisted_110 = /*#__PURE__*/_createElementVNode("div", { class: "rt-col" }, null, -1)
const _hoisted_111 = { class: "rt-col" }
const _hoisted_112 = { class: "rt-col" }
const _hoisted_113 = { class: "rt-col" }
const _hoisted_114 = /*#__PURE__*/_createTextVNode(" คะแนน")
const _hoisted_115 = { class: "rt-col" }
const _hoisted_116 = /*#__PURE__*/_createTextVNode(" คะแนน")
const _hoisted_117 = { class: "rt-col" }
const _hoisted_118 = /*#__PURE__*/_createTextVNode(" คะแนน")
const _hoisted_119 = { class: "rt-col" }
const _hoisted_120 = /*#__PURE__*/_createTextVNode(" คะแนน")
const _hoisted_121 = { class: "rt-col" }
const _hoisted_122 = /*#__PURE__*/_createTextVNode(" คะแนน")
const _hoisted_123 = { class: "rank-table" }
const _hoisted_124 = /*#__PURE__*/_createStaticVNode("<div class=\"rt-head\"><div class=\"rth-row\"><img src=\"" + _imports_16 + "\" class=\"rt-medal\"><div class=\"rt-title\">อันดับที่ 41-70</div></div><div class=\"rth-row\"><div class=\"rth-col\">สมาชิกที่เป็นนธอ.ใหม่</div><div class=\"rth-col\">การเข้าเรียน</div><div class=\"rth-col\">การโพสต์คอนเทนต์</div><div class=\"rth-col\">การสปอนเซอร์</div><div class=\"rth-col\">คะแนนรวม</div></div></div>", 1)
const _hoisted_125 = { class: "rt-content" }
const _hoisted_126 = /*#__PURE__*/_createElementVNode("div", { class: "rt-col" }, null, -1)
const _hoisted_127 = { class: "rt-col" }
const _hoisted_128 = { class: "rt-col" }
const _hoisted_129 = { class: "rt-col" }
const _hoisted_130 = /*#__PURE__*/_createTextVNode(" คะแนน")
const _hoisted_131 = { class: "rt-col" }
const _hoisted_132 = /*#__PURE__*/_createTextVNode(" คะแนน")
const _hoisted_133 = { class: "rt-col" }
const _hoisted_134 = /*#__PURE__*/_createTextVNode(" คะแนน")
const _hoisted_135 = { class: "rt-col" }
const _hoisted_136 = /*#__PURE__*/_createTextVNode(" คะแนน")
const _hoisted_137 = { class: "rt-col" }
const _hoisted_138 = /*#__PURE__*/_createTextVNode(" คะแนน")
const _hoisted_139 = { class: "table-m" }
const _hoisted_140 = { class: "rank-table" }
const _hoisted_141 = /*#__PURE__*/_createElementVNode("div", { class: "rt-head" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_16,
    class: "rt-medal"
  }),
  /*#__PURE__*/_createElementVNode("div", { class: "rt-title" }, "อันดับที่ 1-20")
], -1)
const _hoisted_142 = { class: "rt-content" }
const _hoisted_143 = /*#__PURE__*/_createElementVNode("div", { class: "rt-col" }, null, -1)
const _hoisted_144 = { class: "rt-col" }
const _hoisted_145 = { class: "rt-col" }
const _hoisted_146 = { class: "rt-col" }
const _hoisted_147 = /*#__PURE__*/_createTextVNode(" คะแนน")
const _hoisted_148 = /*#__PURE__*/_createElementVNode("div", { class: "rt-col" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "btn-expand" })
], -1)
const _hoisted_149 = { class: "rt-content-body" }
const _hoisted_150 = { class: "rt-cb-row" }
const _hoisted_151 = /*#__PURE__*/_createElementVNode("div", { class: "rt-cb-title" }, "การเข้าเรียน", -1)
const _hoisted_152 = { class: "rt-cb-text" }
const _hoisted_153 = /*#__PURE__*/_createTextVNode(" คะแนน")
const _hoisted_154 = { class: "rt-cb-row" }
const _hoisted_155 = /*#__PURE__*/_createElementVNode("div", { class: "rt-cb-title" }, "การโพสต์คอนเทนต์", -1)
const _hoisted_156 = { class: "rt-cb-text" }
const _hoisted_157 = /*#__PURE__*/_createTextVNode(" คะแนน")
const _hoisted_158 = { class: "rt-cb-row" }
const _hoisted_159 = /*#__PURE__*/_createElementVNode("div", { class: "rt-cb-title" }, "การสปอนเซอร์", -1)
const _hoisted_160 = { class: "rt-cb-text" }
const _hoisted_161 = /*#__PURE__*/_createTextVNode(" คะแนน")
const _hoisted_162 = { class: "rt-cb-row" }
const _hoisted_163 = /*#__PURE__*/_createElementVNode("div", { class: "rt-cb-title" }, "สมาชิกที่เป็นนธอ.ใหม่", -1)
const _hoisted_164 = { class: "rt-cb-text" }
const _hoisted_165 = /*#__PURE__*/_createTextVNode(" คะแนน")
const _hoisted_166 = { class: "rank-table" }
const _hoisted_167 = /*#__PURE__*/_createElementVNode("div", { class: "rt-head" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_16,
    class: "rt-medal"
  }),
  /*#__PURE__*/_createElementVNode("div", { class: "rt-title" }, "อันดับที่ 21-40")
], -1)
const _hoisted_168 = { class: "rt-content" }
const _hoisted_169 = /*#__PURE__*/_createElementVNode("div", { class: "rt-col" }, null, -1)
const _hoisted_170 = { class: "rt-col" }
const _hoisted_171 = { class: "rt-col" }
const _hoisted_172 = { class: "rt-col" }
const _hoisted_173 = /*#__PURE__*/_createTextVNode(" คะแนน")
const _hoisted_174 = /*#__PURE__*/_createElementVNode("div", { class: "rt-col" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "btn-expand" })
], -1)
const _hoisted_175 = { class: "rt-content-body" }
const _hoisted_176 = { class: "rt-cb-row" }
const _hoisted_177 = /*#__PURE__*/_createElementVNode("div", { class: "rt-cb-title" }, "การเข้าเรียน", -1)
const _hoisted_178 = { class: "rt-cb-text" }
const _hoisted_179 = /*#__PURE__*/_createTextVNode(" คะแนน")
const _hoisted_180 = { class: "rt-cb-row" }
const _hoisted_181 = /*#__PURE__*/_createElementVNode("div", { class: "rt-cb-title" }, "การโพสต์คอนเทนต์", -1)
const _hoisted_182 = { class: "rt-cb-text" }
const _hoisted_183 = /*#__PURE__*/_createTextVNode(" คะแนน")
const _hoisted_184 = { class: "rt-cb-row" }
const _hoisted_185 = /*#__PURE__*/_createElementVNode("div", { class: "rt-cb-title" }, "การสปอนเซอร์", -1)
const _hoisted_186 = { class: "rt-cb-text" }
const _hoisted_187 = /*#__PURE__*/_createTextVNode(" คะแนน")
const _hoisted_188 = { class: "rt-cb-row" }
const _hoisted_189 = /*#__PURE__*/_createElementVNode("div", { class: "rt-cb-title" }, "สมาชิกที่เป็นนธอ.ใหม่", -1)
const _hoisted_190 = { class: "rt-cb-text" }
const _hoisted_191 = /*#__PURE__*/_createTextVNode(" คะแนน")
const _hoisted_192 = { class: "rank-table" }
const _hoisted_193 = /*#__PURE__*/_createElementVNode("div", { class: "rt-head" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_16,
    class: "rt-medal"
  }),
  /*#__PURE__*/_createElementVNode("div", { class: "rt-title" }, "อันดับที่ 41-70")
], -1)
const _hoisted_194 = { class: "rt-content" }
const _hoisted_195 = /*#__PURE__*/_createElementVNode("div", { class: "rt-col" }, null, -1)
const _hoisted_196 = { class: "rt-col" }
const _hoisted_197 = { class: "rt-col" }
const _hoisted_198 = { class: "rt-col" }
const _hoisted_199 = /*#__PURE__*/_createTextVNode(" คะแนน")
const _hoisted_200 = /*#__PURE__*/_createElementVNode("div", { class: "rt-col" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "btn-expand" })
], -1)
const _hoisted_201 = { class: "rt-content-body" }
const _hoisted_202 = { class: "rt-cb-row" }
const _hoisted_203 = /*#__PURE__*/_createElementVNode("div", { class: "rt-cb-title" }, "การเข้าเรียน", -1)
const _hoisted_204 = { class: "rt-cb-text" }
const _hoisted_205 = /*#__PURE__*/_createTextVNode(" คะแนน")
const _hoisted_206 = { class: "rt-cb-row" }
const _hoisted_207 = /*#__PURE__*/_createElementVNode("div", { class: "rt-cb-title" }, "การโพสต์คอนเทนต์", -1)
const _hoisted_208 = { class: "rt-cb-text" }
const _hoisted_209 = /*#__PURE__*/_createTextVNode(" คะแนน")
const _hoisted_210 = { class: "rt-cb-row" }
const _hoisted_211 = /*#__PURE__*/_createElementVNode("div", { class: "rt-cb-title" }, "การสปอนเซอร์", -1)
const _hoisted_212 = { class: "rt-cb-text" }
const _hoisted_213 = /*#__PURE__*/_createTextVNode(" คะแนน")
const _hoisted_214 = { class: "rt-cb-row" }
const _hoisted_215 = /*#__PURE__*/_createElementVNode("div", { class: "rt-cb-title" }, "สมาชิกที่เป็นนธอ.ใหม่", -1)
const _hoisted_216 = { class: "rt-cb-text" }
const _hoisted_217 = /*#__PURE__*/_createTextVNode(" คะแนน")
const _hoisted_218 = { class: "myteam-bar" }
const _hoisted_219 = { class: "container" }
const _hoisted_220 = { class: "mtb-row" }
const _hoisted_221 = { class: "mtb-col" }
const _hoisted_222 = /*#__PURE__*/_createElementVNode("div", { class: "mtb-title" }, "อันดับที่", -1)
const _hoisted_223 = { class: "mtb-detail" }
const _hoisted_224 = { class: "tag-green" }
const _hoisted_225 = /*#__PURE__*/_createElementVNode("span", null, "อันดับที่", -1)
const _hoisted_226 = { class: "mtb-col" }
const _hoisted_227 = /*#__PURE__*/_createElementVNode("div", { class: "mtb-title" }, "ทีมของคุณ", -1)
const _hoisted_228 = { class: "mtb-detail" }
const _hoisted_229 = { class: "mtb-col" }
const _hoisted_230 = /*#__PURE__*/_createElementVNode("div", { class: "mtb-title" }, "คะแนนรวม", -1)
const _hoisted_231 = { class: "mtb-detail" }
const _hoisted_232 = { class: "mtb-col" }
const _hoisted_233 = /*#__PURE__*/_createElementVNode("div", { class: "mtb-title" }, "ของรางวัล", -1)
const _hoisted_234 = {
  key: 0,
  class: "mtb-detail"
}
const _hoisted_235 = /*#__PURE__*/_createTextVNode("นิวทริไลท์ ")
const _hoisted_236 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_237 = /*#__PURE__*/_createTextVNode("ออลแพลนท์ โปรตีน")
const _hoisted_238 = [
  _hoisted_235,
  _hoisted_236,
  _hoisted_237
]
const _hoisted_239 = {
  key: 1,
  class: "mtb-detail"
}
const _hoisted_240 = /*#__PURE__*/_createTextVNode("นิวทริไลท์ ")
const _hoisted_241 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_242 = /*#__PURE__*/_createTextVNode("น้ำมันปลา")
const _hoisted_243 = [
  _hoisted_240,
  _hoisted_241,
  _hoisted_242
]
const _hoisted_244 = {
  key: 2,
  class: "mtb-detail"
}
const _hoisted_245 = /*#__PURE__*/_createTextVNode("นิวทริไลท์ ")
const _hoisted_246 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_247 = /*#__PURE__*/_createTextVNode("วิตามินบี พลัส")
const _hoisted_248 = [
  _hoisted_245,
  _hoisted_246,
  _hoisted_247
]
const _hoisted_249 = {
  key: 3,
  class: "mtb-detail"
}
const _hoisted_250 = /*#__PURE__*/_createTextVNode("นิวทริไลท์ ")
const _hoisted_251 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_252 = /*#__PURE__*/_createTextVNode("โพรไบโอติก")
const _hoisted_253 = [
  _hoisted_250,
  _hoisted_251,
  _hoisted_252
]
const _hoisted_254 = {
  key: 4,
  class: "mtb-detail"
}
const _hoisted_255 = /*#__PURE__*/_createTextVNode("นิวทริไลท์ ")
const _hoisted_256 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_257 = /*#__PURE__*/_createTextVNode("การ์ลิค")
const _hoisted_258 = [
  _hoisted_255,
  _hoisted_256,
  _hoisted_257
]
const _hoisted_259 = {
  key: 5,
  class: "mtb-detail"
}
const _hoisted_260 = /*#__PURE__*/_createTextVNode("เอ็น บาย ")
const _hoisted_261 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_262 = /*#__PURE__*/_createTextVNode("นิวทริไลท์ เอ็น* ชา")
const _hoisted_263 = [
  _hoisted_260,
  _hoisted_261,
  _hoisted_262
]
const _hoisted_264 = { class: "mtb-col" }
const _hoisted_265 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_15,
    style: {"width":"34px","height":"34px","margin-right":"12px"}
  }),
  /*#__PURE__*/_createTextVNode("รายละเอียดคะแนน")
], -1)
const _hoisted_266 = { class: "myteam-bar-m" }
const _hoisted_267 = /*#__PURE__*/_createElementVNode("div", { class: "mtb-row head" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "mtbm-col" }, "อันดับที่"),
  /*#__PURE__*/_createElementVNode("div", { class: "mtbm-col" }, "ของรางวัล")
], -1)
const _hoisted_268 = { class: "mtb-row" }
const _hoisted_269 = { class: "mtbm-col" }
const _hoisted_270 = { class: "tag-green" }
const _hoisted_271 = /*#__PURE__*/_createElementVNode("span", null, "อันดับที่", -1)
const _hoisted_272 = {
  key: 0,
  class: "mtbm-col"
}
const _hoisted_273 = /*#__PURE__*/_createTextVNode("นิวทริไลท์ ")
const _hoisted_274 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_275 = /*#__PURE__*/_createTextVNode("ออลแพลนท์ โปรตีน")
const _hoisted_276 = [
  _hoisted_273,
  _hoisted_274,
  _hoisted_275
]
const _hoisted_277 = {
  key: 1,
  class: "mtbm-col"
}
const _hoisted_278 = /*#__PURE__*/_createTextVNode("นิวทริไลท์ ")
const _hoisted_279 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_280 = /*#__PURE__*/_createTextVNode("น้ำมันปลา")
const _hoisted_281 = [
  _hoisted_278,
  _hoisted_279,
  _hoisted_280
]
const _hoisted_282 = {
  key: 2,
  class: "mtbm-col"
}
const _hoisted_283 = /*#__PURE__*/_createTextVNode("นิวทริไลท์ ")
const _hoisted_284 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_285 = /*#__PURE__*/_createTextVNode("วิตามินบี พลัส")
const _hoisted_286 = [
  _hoisted_283,
  _hoisted_284,
  _hoisted_285
]
const _hoisted_287 = {
  key: 3,
  class: "mtbm-col"
}
const _hoisted_288 = {
  key: 4,
  class: "mtbm-col"
}
const _hoisted_289 = /*#__PURE__*/_createTextVNode("นิวทริไลท์ ")
const _hoisted_290 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_291 = /*#__PURE__*/_createTextVNode("โพรไบโอติก")
const _hoisted_292 = [
  _hoisted_289,
  _hoisted_290,
  _hoisted_291
]
const _hoisted_293 = {
  key: 5,
  class: "mtbm-col"
}
const _hoisted_294 = /*#__PURE__*/_createTextVNode("นิวทริไลท์ ")
const _hoisted_295 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_296 = /*#__PURE__*/_createTextVNode("การ์ลิค")
const _hoisted_297 = [
  _hoisted_294,
  _hoisted_295,
  _hoisted_296
]
const _hoisted_298 = {
  key: 6,
  class: "mtbm-col"
}
const _hoisted_299 = /*#__PURE__*/_createTextVNode("เอ็น บาย ")
const _hoisted_300 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_301 = /*#__PURE__*/_createTextVNode("นิวทริไลท์ เอ็น* ชา")
const _hoisted_302 = [
  _hoisted_299,
  _hoisted_300,
  _hoisted_301
]
const _hoisted_303 = {
  key: 7,
  class: "mtbm-col"
}
const _hoisted_304 = /*#__PURE__*/_createStaticVNode("<section class=\"footer\"><div class=\"container\"><div class=\"row mx-0\"><div class=\"footer-logo\"><img src=\"" + _imports_17 + "\" height=\"40px\"></div><div class=\"footer-address\">บริษัท แอมเวย์ (ประเทศไทย) จำกัด <br>1199/1 ถนนรามคำแหง แขวงหัวหมาก เขตบางกะปิ กรุงเทพ ฯ 10240</div><div class=\"footer-call\"><div class=\"footer-call-text\">ต้องการความช่วยเหลือ ?</div><div class=\"footer-call-phone\"><img src=\"" + _imports_18 + "\"><a href=\"tel:+0-2725-8000\">0-2725-8000</a></div></div><div class=\"copy-right\">Copyright 2022, Amway (Thailand) Ltd,.</div></div></div></section>", 1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_router_link, {
          to: "/activity",
          class: "header-logo"
        }, {
          default: _withCtx(() => [
            _hoisted_4
          ]),
          _: 1
        }),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            (_ctx.isFinal)
              ? (_openBlock(), _createBlock(_component_router_link, {
                  key: 0,
                  to: "final_score"
                }, {
                  default: _withCtx(() => [
                    _hoisted_7,
                    _hoisted_8
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (_ctx.isFinal)
              ? (_openBlock(), _createBlock(_component_router_link, {
                  key: 1,
                  to: "leader_board"
                }, {
                  default: _withCtx(() => [
                    _hoisted_9,
                    _hoisted_10
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (_ctx.isFinal)
              ? (_openBlock(), _createBlock(_component_router_link, {
                  key: 2,
                  to: "final_result"
                }, {
                  default: _withCtx(() => [
                    _hoisted_11,
                    _hoisted_12
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (_ctx.currentWeek > 0 && !_ctx.isFinal)
              ? (_openBlock(), _createBlock(_component_router_link, {
                  key: 3,
                  to: "/team_score_board"
                }, {
                  default: _withCtx(() => [
                    _hoisted_13,
                    _hoisted_14
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (_ctx.currentWeek > 0 && !_ctx.isFinal)
              ? (_openBlock(), _createBlock(_component_router_link, {
                  key: 4,
                  to: "/leader_board"
                }, {
                  default: _withCtx(() => [
                    _hoisted_15,
                    _hoisted_16
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            _createVNode(_component_router_link, {
              to: "/challenge",
              class: "btn-red",
              style: {"width":"184px"}
            }, {
              default: _withCtx(() => [
                _hoisted_17
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_18, [
            _createElementVNode("div", {
              class: "profile-icon",
              onClick: _cache[0] || (_cache[0] = ($event: any) => {_ctx.showProfileInfo();})
            }, [
              _createElementVNode("img", {
                src: _ctx.$store.state.userInfo.profile_image ? _ctx.$store.state.userInfo.profile_image : require('@/assets/images/landing/people.svg')
              }, null, 8, _hoisted_19)
            ]),
            _createElementVNode("div", _hoisted_20, [
              _createElementVNode("div", _hoisted_21, [
                _hoisted_22,
                _createElementVNode("div", null, [
                  _createElementVNode("div", _hoisted_23, _toDisplayString(_ctx.$store.state.userInfo.name), 1),
                  _createElementVNode("div", _hoisted_24, "รหัสนักธุรกิจแอมเวย์ " + _toDisplayString(_ctx.$store.state.userInfo.abo_id), 1)
                ])
              ]),
              (!_ctx.isFinal)
                ? (_openBlock(), _createBlock(_component_router_link, {
                    key: 0,
                    to: "/profile",
                    class: "link-black"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_25,
                      _hoisted_26
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              _hoisted_27
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_28, [
        _createElementVNode("div", _hoisted_29, [
          _createElementVNode("div", {
            class: "ham",
            id: "mobile-menu",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.openMenu(this)))
          }),
          _createVNode(_component_router_link, {
            to: "/challenge",
            class: "header-logo"
          }, {
            default: _withCtx(() => [
              _hoisted_30
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_31, [
          _createElementVNode("div", {
            class: "profile-icon",
            onClick: _cache[2] || (_cache[2] = ($event: any) => {_ctx.showProfileInfo();})
          }, [
            _createElementVNode("img", {
              src: _ctx.$store.state.userInfo.profile_image ? _ctx.$store.state.userInfo.profile_image : require('@/assets/images/landing/people.svg')
            }, null, 8, _hoisted_32)
          ]),
          _createElementVNode("div", _hoisted_33, [
            _createElementVNode("div", _hoisted_34, [
              _hoisted_35,
              _createElementVNode("div", null, [
                _createElementVNode("div", _hoisted_36, _toDisplayString(_ctx.$store.state.userInfo.name), 1),
                _createElementVNode("div", _hoisted_37, "รหัสนักธุรกิจแอมเวย์ " + _toDisplayString(_ctx.$store.state.userInfo.abo_id), 1)
              ])
            ]),
            (!_ctx.isFinal)
              ? (_openBlock(), _createBlock(_component_router_link, {
                  key: 0,
                  to: "/profile",
                  class: "link-black"
                }, {
                  default: _withCtx(() => [
                    _hoisted_38,
                    _hoisted_39
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            _hoisted_40
          ])
        ]),
        _createElementVNode("div", _hoisted_41, [
          (_ctx.isFinal)
            ? (_openBlock(), _createBlock(_component_router_link, {
                key: 0,
                to: "final_score"
              }, {
                default: _withCtx(() => [
                  _hoisted_42,
                  _hoisted_43
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (_ctx.isFinal)
            ? (_openBlock(), _createBlock(_component_router_link, {
                key: 1,
                to: "leader_board"
              }, {
                default: _withCtx(() => [
                  _hoisted_44,
                  _hoisted_45
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (_ctx.isFinal)
            ? (_openBlock(), _createBlock(_component_router_link, {
                key: 2,
                to: "final_result"
              }, {
                default: _withCtx(() => [
                  _hoisted_46,
                  _hoisted_47
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (_ctx.currentWeek > 0 && !_ctx.isFinal)
            ? (_openBlock(), _createBlock(_component_router_link, {
                key: 3,
                to: "team_score_board"
              }, {
                default: _withCtx(() => [
                  _hoisted_48,
                  _hoisted_49
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (_ctx.currentWeek > 0 && !_ctx.isFinal)
            ? (_openBlock(), _createBlock(_component_router_link, {
                key: 4,
                to: "leader_board"
              }, {
                default: _withCtx(() => [
                  _hoisted_50,
                  _hoisted_51
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          _createVNode(_component_router_link, {
            to: "/challenge",
            class: "btn-red fixed",
            style: {"right":"16px","bottom":"0","width":"calc(100% - 32px)"},
            onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.openMenu()))
          }, {
            default: _withCtx(() => [
              _hoisted_52
            ]),
            _: 1
          })
        ])
      ]),
      _createElementVNode("div", _hoisted_53, [
        _createVNode(_component_router_link, {
          to: "/activity",
          class: "btn-back",
          style: {"margin-top":"0"}
        }, {
          default: _withCtx(() => [
            _hoisted_54
          ]),
          _: 1
        }),
        _hoisted_55
      ])
    ]),
    _createElementVNode("section", _hoisted_56, [
      _createElementVNode("div", _hoisted_57, [
        _createElementVNode("div", _hoisted_58, [
          _createElementVNode("div", _hoisted_59, [
            _createVNode(_component_router_link, {
              to: "/activity",
              class: "btn-back"
            }, {
              default: _withCtx(() => [
                _hoisted_60,
                _hoisted_61
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_62, [
            _createElementVNode("div", _hoisted_63, "สัปดาห์ที่ " + _toDisplayString(_ctx.currentWeek), 1)
          ]),
          (_ctx.currentWeek >= 1 && _ctx.currentWeek <= 5)
            ? (_openBlock(), _createElementBlock("div", _hoisted_64, _hoisted_68))
            : _createCommentVNode("", true),
          (_ctx.currentWeek >= 6 && _ctx.currentWeek <= 11)
            ? (_openBlock(), _createElementBlock("div", _hoisted_69, _hoisted_73))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_74, [
          _hoisted_75,
          _createElementVNode("div", _hoisted_76, [
            _createElementVNode("div", _hoisted_77, [
              _createElementVNode("div", _hoisted_78, [
                _createElementVNode("span", null, "อันดับที่ " + _toDisplayString(_ctx.team.rank), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_79, _toDisplayString(_ctx.team.team_name), 1),
            _createElementVNode("div", _hoisted_80, _toDisplayString(_ctx.team.team_total_score) + " คะแนน", 1),
            (_ctx.currentWeek >= 1 && _ctx.currentWeek <= 5 && _ctx.team.rank >= 1 && _ctx.team.rank <= 20)
              ? (_openBlock(), _createElementBlock("div", _hoisted_81, "นิวทริไลท์ ออลแพลนท์ โปรตีน"))
              : _createCommentVNode("", true),
            (_ctx.currentWeek >= 1 && _ctx.currentWeek <= 5 && _ctx.team.rank >= 21 && _ctx.team.rank <= 40)
              ? (_openBlock(), _createElementBlock("div", _hoisted_82, "นิวทริไลท์ น้ำมันปลา"))
              : _createCommentVNode("", true),
            (_ctx.currentWeek >= 1 && _ctx.currentWeek <= 5 && _ctx.team.rank >= 41 && _ctx.team.rank <= 70)
              ? (_openBlock(), _createElementBlock("div", _hoisted_83, "นิวทริไลท์ วิตามินบี พลัส"))
              : _createCommentVNode("", true),
            (_ctx.currentWeek >= 6 && _ctx.currentWeek <= 11 && _ctx.team.rank >= 1 && _ctx.team.rank <= 20)
              ? (_openBlock(), _createElementBlock("div", _hoisted_84, "นิวทริไลท์ โพรไบโอติก"))
              : _createCommentVNode("", true),
            (_ctx.currentWeek >= 6 && _ctx.currentWeek <= 11 && _ctx.team.rank >= 21 && _ctx.team.rank <= 40)
              ? (_openBlock(), _createElementBlock("div", _hoisted_85, "นิวทริไลท์ การ์ลิค"))
              : _createCommentVNode("", true),
            (_ctx.currentWeek >= 6 && _ctx.currentWeek <= 11 && _ctx.team.rank >= 41 && _ctx.team.rank <= 70)
              ? (_openBlock(), _createElementBlock("div", _hoisted_86, "เอ็น บาย นิวทริไลท์ เอ็น* ชา"))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_87, [
            _createElementVNode("div", _hoisted_88, [
              _createVNode(_component_router_link, {
                to: "/team_score_board",
                class: "btn-red",
                style: {"margin":"0 auto"}
              }, {
                default: _withCtx(() => [
                  _hoisted_89
                ]),
                _: 1
              })
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_90, [
          _createElementVNode("div", _hoisted_91, [
            _hoisted_92,
            _createElementVNode("div", _hoisted_93, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.ranks.slice(0, 20), (rank) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: _normalizeClass(["rt-row", `rt-row ${rank.team_name ==  _ctx.team.team_name ? 'my-team' : ''}`]),
                  key: rank.rank
                }, [
                  _hoisted_94,
                  _createElementVNode("div", _hoisted_95, _toDisplayString(rank.rank) + ".", 1),
                  _createElementVNode("div", _hoisted_96, _toDisplayString(rank.team_name), 1),
                  _createElementVNode("div", _hoisted_97, [
                    _createElementVNode("span", null, _toDisplayString(rank.sum_team_score.new_member), 1),
                    _hoisted_98
                  ]),
                  _createElementVNode("div", _hoisted_99, [
                    _createElementVNode("span", null, _toDisplayString(rank.sum_team_score.online_class), 1),
                    _hoisted_100
                  ]),
                  _createElementVNode("div", _hoisted_101, [
                    _createElementVNode("span", null, _toDisplayString(rank.sum_team_score.social_posting), 1),
                    _hoisted_102
                  ]),
                  _createElementVNode("div", _hoisted_103, [
                    _createElementVNode("span", null, _toDisplayString(rank.sum_team_score.sponsoring), 1),
                    _hoisted_104
                  ]),
                  _createElementVNode("div", _hoisted_105, [
                    _createElementVNode("span", null, _toDisplayString(+rank.sum_team_score.new_member + +rank.sum_team_score.online_class + +rank.sum_team_score.social_posting + +rank.sum_team_score.sponsoring), 1),
                    _hoisted_106
                  ])
                ], 2))
              }), 128))
            ])
          ]),
          _createElementVNode("div", _hoisted_107, [
            _hoisted_108,
            _createElementVNode("div", _hoisted_109, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.ranks.slice(20, 40), (rank) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: _normalizeClass(["rt-row", `rt-row ${rank.team_name ==  _ctx.team.team_name ? 'my-team' : ''}`]),
                  key: rank.rank
                }, [
                  _hoisted_110,
                  _createElementVNode("div", _hoisted_111, _toDisplayString(rank.rank) + ".", 1),
                  _createElementVNode("div", _hoisted_112, _toDisplayString(rank.team_name), 1),
                  _createElementVNode("div", _hoisted_113, [
                    _createElementVNode("span", null, _toDisplayString(rank.sum_team_score.new_member), 1),
                    _hoisted_114
                  ]),
                  _createElementVNode("div", _hoisted_115, [
                    _createElementVNode("span", null, _toDisplayString(rank.sum_team_score.online_class), 1),
                    _hoisted_116
                  ]),
                  _createElementVNode("div", _hoisted_117, [
                    _createElementVNode("span", null, _toDisplayString(rank.sum_team_score.social_posting), 1),
                    _hoisted_118
                  ]),
                  _createElementVNode("div", _hoisted_119, [
                    _createElementVNode("span", null, _toDisplayString(rank.sum_team_score.sponsoring), 1),
                    _hoisted_120
                  ]),
                  _createElementVNode("div", _hoisted_121, [
                    _createElementVNode("span", null, _toDisplayString(+rank.sum_team_score.new_member + +rank.sum_team_score.online_class + +rank.sum_team_score.social_posting + +rank.sum_team_score.sponsoring), 1),
                    _hoisted_122
                  ])
                ], 2))
              }), 128))
            ])
          ]),
          _createElementVNode("div", _hoisted_123, [
            _hoisted_124,
            _createElementVNode("div", _hoisted_125, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.ranks.slice(40, 70), (rank) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: _normalizeClass(["rt-row", `rt-row ${rank.team_name ==  _ctx.team.team_name ? 'my-team' : ''}`]),
                  key: rank.rank
                }, [
                  _hoisted_126,
                  _createElementVNode("div", _hoisted_127, _toDisplayString(rank.rank) + ".", 1),
                  _createElementVNode("div", _hoisted_128, _toDisplayString(rank.team_name), 1),
                  _createElementVNode("div", _hoisted_129, [
                    _createElementVNode("span", null, _toDisplayString(rank.sum_team_score.new_member), 1),
                    _hoisted_130
                  ]),
                  _createElementVNode("div", _hoisted_131, [
                    _createElementVNode("span", null, _toDisplayString(rank.sum_team_score.online_class), 1),
                    _hoisted_132
                  ]),
                  _createElementVNode("div", _hoisted_133, [
                    _createElementVNode("span", null, _toDisplayString(rank.sum_team_score.social_posting), 1),
                    _hoisted_134
                  ]),
                  _createElementVNode("div", _hoisted_135, [
                    _createElementVNode("span", null, _toDisplayString(rank.sum_team_score.sponsoring), 1),
                    _hoisted_136
                  ]),
                  _createElementVNode("div", _hoisted_137, [
                    _createElementVNode("span", null, _toDisplayString(+rank.sum_team_score.new_member + +rank.sum_team_score.online_class + +rank.sum_team_score.social_posting + +rank.sum_team_score.sponsoring), 1),
                    _hoisted_138
                  ])
                ], 2))
              }), 128))
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_139, [
          _createElementVNode("div", _hoisted_140, [
            _hoisted_141,
            _createElementVNode("div", _hoisted_142, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.ranks.slice(0, 20), (rank) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: _normalizeClass(["rt-row", `rt-row ${rank.team_name ==  _ctx.team.team_name ? 'my-team' : ''}`]),
                  key: rank.rank
                }, [
                  _createElementVNode("div", {
                    class: "rt-content-head",
                    onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.showContent($event)))
                  }, [
                    _hoisted_143,
                    _createElementVNode("div", _hoisted_144, _toDisplayString(rank.rank) + ".", 1),
                    _createElementVNode("div", _hoisted_145, _toDisplayString(rank.team_name), 1),
                    _createElementVNode("div", _hoisted_146, [
                      _createElementVNode("span", null, _toDisplayString(+rank.sum_team_score.new_member + +rank.sum_team_score.online_class + +rank.sum_team_score.social_posting + +rank.sum_team_score.sponsoring), 1),
                      _hoisted_147
                    ]),
                    _hoisted_148
                  ]),
                  _createElementVNode("div", _hoisted_149, [
                    _createElementVNode("div", _hoisted_150, [
                      _hoisted_151,
                      _createElementVNode("div", _hoisted_152, [
                        _createElementVNode("span", null, _toDisplayString(rank.sum_team_score.online_class), 1),
                        _hoisted_153
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_154, [
                      _hoisted_155,
                      _createElementVNode("div", _hoisted_156, [
                        _createElementVNode("span", null, _toDisplayString(rank.sum_team_score.social_posting), 1),
                        _hoisted_157
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_158, [
                      _hoisted_159,
                      _createElementVNode("div", _hoisted_160, [
                        _createElementVNode("span", null, _toDisplayString(rank.sum_team_score.sponsoring), 1),
                        _hoisted_161
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_162, [
                      _hoisted_163,
                      _createElementVNode("div", _hoisted_164, [
                        _createElementVNode("span", null, _toDisplayString(rank.sum_team_score.new_member), 1),
                        _hoisted_165
                      ])
                    ])
                  ])
                ], 2))
              }), 128))
            ])
          ]),
          _createElementVNode("div", _hoisted_166, [
            _hoisted_167,
            _createElementVNode("div", _hoisted_168, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.ranks.slice(20, 40), (rank) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: _normalizeClass(["rt-row", `rt-row ${rank.team_name ==  _ctx.team.team_name ? 'my-team' : ''}`]),
                  key: rank.rank
                }, [
                  _createElementVNode("div", {
                    class: "rt-content-head",
                    onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.showContent($event)))
                  }, [
                    _hoisted_169,
                    _createElementVNode("div", _hoisted_170, _toDisplayString(rank.rank) + ".", 1),
                    _createElementVNode("div", _hoisted_171, _toDisplayString(rank.team_name), 1),
                    _createElementVNode("div", _hoisted_172, [
                      _createElementVNode("span", null, _toDisplayString(+rank.sum_team_score.new_member + +rank.sum_team_score.online_class + +rank.sum_team_score.social_posting + +rank.sum_team_score.sponsoring), 1),
                      _hoisted_173
                    ]),
                    _hoisted_174
                  ]),
                  _createElementVNode("div", _hoisted_175, [
                    _createElementVNode("div", _hoisted_176, [
                      _hoisted_177,
                      _createElementVNode("div", _hoisted_178, [
                        _createElementVNode("span", null, _toDisplayString(rank.sum_team_score.online_class), 1),
                        _hoisted_179
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_180, [
                      _hoisted_181,
                      _createElementVNode("div", _hoisted_182, [
                        _createElementVNode("span", null, _toDisplayString(rank.sum_team_score.social_posting), 1),
                        _hoisted_183
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_184, [
                      _hoisted_185,
                      _createElementVNode("div", _hoisted_186, [
                        _createElementVNode("span", null, _toDisplayString(rank.sum_team_score.sponsoring), 1),
                        _hoisted_187
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_188, [
                      _hoisted_189,
                      _createElementVNode("div", _hoisted_190, [
                        _createElementVNode("span", null, _toDisplayString(rank.sum_team_score.new_member), 1),
                        _hoisted_191
                      ])
                    ])
                  ])
                ], 2))
              }), 128))
            ])
          ]),
          _createElementVNode("div", _hoisted_192, [
            _hoisted_193,
            _createElementVNode("div", _hoisted_194, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.ranks.slice(40, 70), (rank) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: _normalizeClass(["rt-row", `rt-row ${rank.team_name ==  _ctx.team.team_name ? 'my-team' : ''}`]),
                  key: rank.rank
                }, [
                  _createElementVNode("div", {
                    class: "rt-content-head",
                    onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.showContent($event)))
                  }, [
                    _hoisted_195,
                    _createElementVNode("div", _hoisted_196, _toDisplayString(rank.rank) + ".", 1),
                    _createElementVNode("div", _hoisted_197, _toDisplayString(rank.team_name), 1),
                    _createElementVNode("div", _hoisted_198, [
                      _createElementVNode("span", null, _toDisplayString(+rank.sum_team_score.new_member + +rank.sum_team_score.online_class + +rank.sum_team_score.social_posting + +rank.sum_team_score.sponsoring), 1),
                      _hoisted_199
                    ]),
                    _hoisted_200
                  ]),
                  _createElementVNode("div", _hoisted_201, [
                    _createElementVNode("div", _hoisted_202, [
                      _hoisted_203,
                      _createElementVNode("div", _hoisted_204, [
                        _createElementVNode("span", null, _toDisplayString(rank.sum_team_score.online_class), 1),
                        _hoisted_205
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_206, [
                      _hoisted_207,
                      _createElementVNode("div", _hoisted_208, [
                        _createElementVNode("span", null, _toDisplayString(rank.sum_team_score.social_posting), 1),
                        _hoisted_209
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_210, [
                      _hoisted_211,
                      _createElementVNode("div", _hoisted_212, [
                        _createElementVNode("span", null, _toDisplayString(rank.sum_team_score.sponsoring), 1),
                        _hoisted_213
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_214, [
                      _hoisted_215,
                      _createElementVNode("div", _hoisted_216, [
                        _createElementVNode("span", null, _toDisplayString(rank.sum_team_score.new_member), 1),
                        _hoisted_217
                      ])
                    ])
                  ])
                ], 2))
              }), 128))
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_218, [
      _createElementVNode("div", _hoisted_219, [
        _createElementVNode("div", _hoisted_220, [
          _createElementVNode("div", _hoisted_221, [
            _hoisted_222,
            _createElementVNode("div", _hoisted_223, [
              _createElementVNode("div", _hoisted_224, [
                _hoisted_225,
                _createTextVNode(" " + _toDisplayString(_ctx.team.rank), 1)
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_226, [
            _hoisted_227,
            _createElementVNode("div", _hoisted_228, _toDisplayString(_ctx.team.team_name), 1)
          ]),
          _createElementVNode("div", _hoisted_229, [
            _hoisted_230,
            _createElementVNode("div", _hoisted_231, _toDisplayString(_ctx.team.team_total_score) + " คะแนน", 1)
          ]),
          _createElementVNode("div", _hoisted_232, [
            _hoisted_233,
            (_ctx.currentWeek >= 1 && _ctx.currentWeek <= 5 && _ctx.team.rank >= 1 && _ctx.team.rank <= 20)
              ? (_openBlock(), _createElementBlock("div", _hoisted_234, _hoisted_238))
              : _createCommentVNode("", true),
            (_ctx.currentWeek >= 1 && _ctx.currentWeek <= 5 && _ctx.team.rank >= 21 && _ctx.team.rank <= 40)
              ? (_openBlock(), _createElementBlock("div", _hoisted_239, _hoisted_243))
              : _createCommentVNode("", true),
            (_ctx.currentWeek >= 1 && _ctx.currentWeek <= 5 && _ctx.team.rank >= 41 && _ctx.team.rank <= 70)
              ? (_openBlock(), _createElementBlock("div", _hoisted_244, _hoisted_248))
              : _createCommentVNode("", true),
            (_ctx.currentWeek >= 6 && _ctx.currentWeek <= 11 && _ctx.team.rank >= 1 && _ctx.team.rank <= 20)
              ? (_openBlock(), _createElementBlock("div", _hoisted_249, _hoisted_253))
              : _createCommentVNode("", true),
            (_ctx.currentWeek >= 6 && _ctx.currentWeek <= 11 && _ctx.team.rank >= 21 && _ctx.team.rank <= 40)
              ? (_openBlock(), _createElementBlock("div", _hoisted_254, _hoisted_258))
              : _createCommentVNode("", true),
            (_ctx.currentWeek >= 6 && _ctx.currentWeek <= 11 && _ctx.team.rank >= 41 && _ctx.team.rank <= 70)
              ? (_openBlock(), _createElementBlock("div", _hoisted_259, _hoisted_263))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_264, [
            _createVNode(_component_router_link, {
              to: "/team_score_board",
              class: "btn-red"
            }, {
              default: _withCtx(() => [
                _hoisted_265
              ]),
              _: 1
            })
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_266, [
      _hoisted_267,
      _createElementVNode("div", _hoisted_268, [
        _createElementVNode("div", _hoisted_269, [
          _createElementVNode("div", _hoisted_270, [
            _hoisted_271,
            _createTextVNode(" " + _toDisplayString(_ctx.team.rank), 1)
          ])
        ]),
        (_ctx.currentWeek >= 1 && _ctx.currentWeek <= 5 && _ctx.team.rank >= 1 && _ctx.team.rank <= 20)
          ? (_openBlock(), _createElementBlock("div", _hoisted_272, _hoisted_276))
          : _createCommentVNode("", true),
        (_ctx.currentWeek >= 1 && _ctx.currentWeek <= 5 && _ctx.team.rank >= 21 && _ctx.team.rank <= 40)
          ? (_openBlock(), _createElementBlock("div", _hoisted_277, _hoisted_281))
          : _createCommentVNode("", true),
        (_ctx.currentWeek >= 1 && _ctx.currentWeek <= 5 && _ctx.team.rank >= 41 && _ctx.team.rank <= 70)
          ? (_openBlock(), _createElementBlock("div", _hoisted_282, _hoisted_286))
          : _createCommentVNode("", true),
        (_ctx.currentWeek >= 1 && _ctx.currentWeek <= 5 && _ctx.team.rank > 70)
          ? (_openBlock(), _createElementBlock("div", _hoisted_287, "-"))
          : _createCommentVNode("", true),
        (_ctx.currentWeek >= 6 && _ctx.currentWeek <= 11 && _ctx.team.rank >= 1 && _ctx.team.rank <= 20)
          ? (_openBlock(), _createElementBlock("div", _hoisted_288, _hoisted_292))
          : _createCommentVNode("", true),
        (_ctx.currentWeek >= 6 && _ctx.currentWeek <= 11 && _ctx.team.rank >= 21 && _ctx.team.rank <= 40)
          ? (_openBlock(), _createElementBlock("div", _hoisted_293, _hoisted_297))
          : _createCommentVNode("", true),
        (_ctx.currentWeek >= 6 && _ctx.currentWeek <= 11 && _ctx.team.rank >= 41 && _ctx.team.rank <= 70)
          ? (_openBlock(), _createElementBlock("div", _hoisted_298, _hoisted_302))
          : _createCommentVNode("", true),
        (_ctx.currentWeek >= 6 && _ctx.currentWeek <= 11 && _ctx.team.rank > 70)
          ? (_openBlock(), _createElementBlock("div", _hoisted_303, "-"))
          : _createCommentVNode("", true)
      ])
    ]),
    _hoisted_304
  ]))
}